<fgb-page-header
  [pageTitle]="isGalleryPage ? 'gallery.page.title' : 'worksheets.page.title'"
  [showBalance]="false"
  [showFooter]="isWorksheetPage"
  [backButtonLink]="'/'"
></fgb-page-header>
<div class="page-padding">
  <fgb-worksheet-list [isGalleryPage]="isGalleryPage" [isWorksheetPage]="isWorksheetPage" [colOverride]="'gallery-item-container'"></fgb-worksheet-list>
</div>
